module.exports = __webpack_public_path__ + "static/img/region_distribution_2.0012dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/region_distribution_2.png
// module id = L1dA
// module chunks = 6